<template>
    <b-form-group
        :label="label"
        class="">
        <gmap-autocomplete
            class="form-control"
            v-model="address"
            :options="options"
            v-on:place_changed="setPlace">
        </gmap-autocomplete>
        <small>{{ description }}</small>
    </b-form-group>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';

export default {
    name: "AddressAutocompleteComponent",

    components: { },

    props: ['value', 'label', 'description', 'config'],

    computed: {
        formatter() {
            return _.get(this.config, 'formatter');
        },

        address() {
            return this.getAddressValue(this.value);
        },

        options() {
            let options = {};
            let country = _.get(this.config, 'country')

            if (country) {
                options.componentRestrictions = {
                    country
                }
            }

            return options;
        }
    },


    methods: {
        // receives a place object via the autocomplete component
        setPlace(place) {
            let value = place;
            if (_.isFunction(this.formatter)) {
                value = this.formatter(place);
            }
            this.$emit('input', value);
        },

        getAddressValue(place) {
            if (_.isNil(place)) {
                return '';
            } else if (_.isString(place)) {
                return place;
            } else if (_.isObject(place)) {
                return place.formatted_address || '';
            } else {
                return '';
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/AddressAutocompleteComponent.vue